import React, { useRef, type ComponentClass } from 'react';
import { ApplicationView } from '@aha-app/mvc';
import Tippy from '@tippyjs/react';
import { type Instance as TippyInstance } from 'tippy.js/index';
import styles from '../styles.module.css';

interface WithSubMenuProps {
  MenuComponent?:
    | ComponentClass<any, any>
    | React.FC<{
        menuTippyRef?: React.MutableRefObject<TippyInstance | undefined>;
      }>;
  visible: boolean;
  children: React.ReactNode;
}

const WithSubMenu: React.FC<WithSubMenuProps> = ({
  MenuComponent,
  visible,
  children,
}) => {
  const tippyRef = useRef<TippyInstance>();
  if (MenuComponent) {
    return (
      <Tippy
        arrow={false}
        content={<MenuComponent menuTippyRef={tippyRef} />}
        onShow={instance => {
          tippyRef.current = instance;
        }}
        theme='aha-themed'
        interactive
        placement='right'
        visible={visible}
        duration={75}
        animation='scale'
        className={styles.toolbarSubMenu}
      >
        {/* @ts-expect-error ReactNode/ReactElement type mismatch */}
        {children}
      </Tippy>
    );
  } else {
    return <>{children}</>;
  }
};

export default ApplicationView(WithSubMenu);
